import { render } from "./branch-update.vue?vue&type=template&id=9ba41206"
import script from "./branch-update.vue?vue&type=script&lang=js"
export * from "./branch-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__